import React, {Fragment} from 'react';
import {Nav, NavItem} from "react-bootstrap";
import {withRouter} from 'react-router-dom';

export const Header = withRouter(({history}) => {
  const navItems = [
    {to: "/customers", title: "Customers"},
    {to: "/i18n/editor", title: "Translations"}
  ];
  return (
    <Fragment>
      <h1 style={{textAlign:"center"}}>Admin Portal</h1>
      <Nav bsStyle="tabs" activeKey={window.location.pathname} onSelect={(key) => history.push(key)}>
        {navItems.map(({to, title}, index) => <NavItem
          active={window.location.pathname.startsWith(to)}
          eventKey={to}
          key={index}
        >
            {title}
        </NavItem>)}
      </Nav>
    </Fragment>
  );
});


// WEBPACK FOOTER //
// ./src/components/layout/Header.js